/**
 * Rota da tela de cobranca da licenca.
 *
 * Em arquivo proprio e exportada como array para que index.js mude em duas
 * linhas apenas (import + spread antes do fecha-array) — as branches de cliente
 * divergem bastante no meio de routes, e essa e a posicao com contexto igual
 * nos dois lados.
 *
 * Declarada FORA do `{ path: "/", component: Layout }`: nao passa por
 * verificaRota(), portanto NAO precisa de entrada no Menu.js, nao herda o menu
 * nem a trava de localizacao, e nao exige usuario do sistema.
 */

import store from "../store";

export default [
  {
    path: "/pg",
    name: "PgAdmin",
    beforeEnter(to, from, next) {
      // store.state.loading nasce true e o overlay do App.vue tem z-index 9999;
      // so verificaRota() e o /login o desligam hoje.
      store.state.loading = false;
      next();
    },
    component: () =>
      import(/* webpackChunkName: "pg" */ "@/views/pg/PgAdmin.vue"),
  },
];
